module.exports = __webpack_public_path__ + "img/school_esyc1.ee69e666.png";